// 引入后进行初始化
import Aegis from '@tencent/aegis-web-sdk';

export const aegisInstance = new Aegis({
  id: 'GKcUKXXvlVeaFmRWJS', // 项目ID，即上报id
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 页面需要开启，页面切换的时候上报pv
});
